import React from 'react';
import { TextAreaFieldTW } from '../../../../tailwindComponents/textAreaTW/TextAreaFieldTW';
import { useFormikContext } from 'formik';

interface OrderContactNotesFieldProps {
  readonly name: string;
}
// An AreaField that trims its value on blur
export function OrderContactNotesField<T>({ name }: OrderContactNotesFieldProps) {
  const { getFieldMeta, setFieldValue } = useFormikContext<T>();
  const { value } = getFieldMeta<string | undefined>(name);

  return (
    <TextAreaFieldTW
      name={name}
      labelText={'Notes'}
      placeholder={'Notes...'}
      rows={2}
      onBlur={() => {
        setFieldValue(name, value?.trim());
      }}
    />
  );
}
